import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import Masonry from "react-masonry-css";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import "./Gallery.css";
import { useHistory } from "react-router-dom";
import { useCallback } from "react";
import { Button, Col, Row } from "reactstrap";
import { Eye } from "@phosphor-icons/react";

const Gallery = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const galleryId = searchParams.get("id");

  const [images, setImages] = useState([]);
  const [lightboxImages, setLightboxImages] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const history = useHistory();

  const redirectToHome = useCallback(() => {
    history.push("/");
  }, [history]);
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        setIsOpen(false);
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);


  const breakpointColumnsObj = {
    default: 4, // 4 columns on large screens
    1100: 3, // 3 columns on medium screens
    700: 2, // 2 columns on mobile screens
    500: 2, // 1 column on very small screens
  };

  const addingselection = async (code, type = "add") => {
    try {
      const response = await axios.post(
        // "http://localhost:4000/api/imagequeue/selection",
        `https://dreamsjewels-stock.fly.dev/api/imagequeue/selection`,
        {
          id: galleryId,   // ImageQueue ID
          code: code,      // Image code
          type: type       // "add" or "remove"
        }
      );
      console.log("Selection updated:", response.data);

      // Optional: Update local state so UI reflects selection
      setImages((prev) =>
        prev.map((img) =>
          img.code === code ? { ...img, selected: type === "add" } : img
        )
      );

    } catch (err) {
      console.error("Error updating selection:", err);
      alert("Failed to update selection");
    }
  };


  useEffect(() => {
    if (!galleryId) {
      setError("No gallery ID provided.");
      setLoading(false);
      return;
    }



    const fetchGallery = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          // `http://localhost:4000/api/gallery/${galleryId}`
          `https://dreamsjewels-stock.fly.dev/api/gallery/${galleryId}`
        );
        setImages(response.data.data.images);
        if(response){
        setLoading(false);

        }
        // Convert images for ImageGallery format
        const formattedImages = response.data.data.images.map((img) => ({
          original: img.url,
          thumbnail: img.url,
          description: img.code, // Add code in the lightbox
        }));
        setLightboxImages(formattedImages);
      } catch (err) {
        setError("Failed to load images.");
        redirectToHome(); // Redirect on error
      } finally {
        setLoading(false);
      }
    };

    fetchGallery();
  }, [galleryId]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;


  const selectionCount = images.filter(img => img.selected).length;

if (loading) {
   return(
     <div className='loading'>
      <img className='loadinggif' src={process.env.PUBLIC_URL + "/images/loading.gif"} />
    </div>
   )
  }


  return (
    <div className="gallery-container">
      <br />
      <center>
        <h1 className="mainheading-text">PICKED FOR YOU</h1>
        <br />
        <p className="selectioncount" style={{ fontSize: "18px", fontWeight: "500", marginTop: "-10px" }}>
          Selection count: {selectionCount}
        </p>
      </center>

      {/* Masonry Grid */}
      <Masonry
        breakpointCols={breakpointColumnsObj}
        className="gallery-masonry"
        columnClassName="gallery-column"
      >

        {images.map((img, index) => (
          <div key={index} className="gallery-item">
            {/* ✅ Image Wrapper */}
            <div className="" style={{ position: "relative" }}>
              <img
                src={img.urls[0]}
                alt={`Gallery ${index}`}
                className="gallery-image"
                onClick={() => {
                  setSelectedIndex(index);
                  setIsOpen(true);
                }}
              />

              {/* ✅ Overlay now positioned relative to the image only */}
              {img.urls[1] && (
                <div
                  className="image-overlay"
                  style={{
                    position: "absolute",
                    bottom: "8px",
                    right: "8px",
                    width: "50px",
                    height: "50px",
                    borderRadius: "6px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "12px",
                    fontWeight: "bold",
                    color: "white",
                    background: `
              linear-gradient(
                rgba(0,0,0,0.5), 
                rgba(0,0,0,0.5)
              ),
              url(${img.urls[1]})
            `,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                >
                  +{img.urls.length - 1}
                </div>
              )}
            </div>

            {/* ✅ Image details below */}
            <p className="image-code">{img.code}</p>
            <p className="image-code">{img.category}</p>

            <div className="selectioncode">
              <Col>
                <Row className="gallery-btn-gap">
                  <Button
                    className="viewdetails-glry-btn"
                  >
                  <Link className="viewdetailsbtn" to={`/gallery/${galleryId}/${img.id}`}>
                    <Eye size={16} /> View Details
                  </Link>
                  </Button>
                </Row>
                <Row>
                  <Button
                    className={img.selected ? "cancelclass" : "selectclass"}
                    onClick={() =>
                      addingselection(img.code, img.selected ? "remove" : "add")
                    }
                  >
                    {img.selected ? "Remove" : "Select"}
                  </Button>
                </Row>
                
              </Col>



            </div>
          </div>
        ))}

      </Masonry>


      {/* Lightbox with Thumbnail Slider */}
      {isOpen && images[selectedIndex] && (
        <div className="lightbox-overlay" onClick={() => setIsOpen(false)}>
          <div className="lightbox-container" onClick={(e) => e.stopPropagation()}>

            <div className="lightbox-header">
              <h3>{images[selectedIndex].code}</h3>

              <Button
                color={images[selectedIndex].selected ? "danger" : "success"}
                onClick={() =>
                  addingselection(
                    images[selectedIndex].code,
                    images[selectedIndex].selected ? "remove" : "add"
                  )
                }
                style={{ marginLeft: "15px" }}
              >
                {images[selectedIndex].selected ? "Remove from Selection" : "Add to Selection"}
              </Button>
            </div>


            <div className="lightbox-gallery-wrapper">
              {selectedIndex > 0 && (
                <button
                  className="lightbox-product-button prev"
                  onClick={() => setSelectedIndex((prev) => prev - 1)}
                >
                  ←
                </button>
              )}

              <div className="lightbox-gallery">
                <ImageGallery
                  items={images[selectedIndex].urls.map((url) => ({
                    original: url,
                    thumbnail: url
                  }))}
                  showThumbnails={true}
                  showFullscreenButton={true}
                  showPlayButton={false}
                  showNav={true}
                  key={selectedIndex}
                />
              </div>

              {selectedIndex < images.length - 1 && (
                <button
                  className="lightbox-product-button next"
                  onClick={() => setSelectedIndex((prev) => prev + 1)}
                >
                  →
                </button>
              )}
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default Gallery;
